import {SubscriptionType} from "../enums/subscription-type";

export const UNLIMITED_CONTENT_LINKS_SUBSCRIPTION_TYPES = [SubscriptionType.PREMIUM, SubscriptionType.PROFESSIONAL, SubscriptionType.UNLIM];
export const UNLIMITED_PAYMENT_METHODS_SUBSCRIPTION_TYPES = [SubscriptionType.PREMIUM, SubscriptionType.PROFESSIONAL, SubscriptionType.UNLIM];
